/* global window, document */
import 'react-app-polyfill/ie9';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { LastLocationProvider } from 'react-router-last-location';
import { createBrowserHistory } from 'history';
import { PersistGate } from 'redux-persist/es/integration/react';
import { MuiThemeProvider } from '@material-ui/core/styles';
import LoadingScreen from 'icw-components/LoadingScreen';
import Notifications from 'icw-components/Notifications';
import theme from 'util/theme';
import App from 'App';
import 'assets/css/antd.css';
import 'assets/css/material-dashboard-react.css';
import 'assets/css/custom.css';
import 'assets/css/material-icon.css';
import 'typeface-roboto';
import { SnackbarProvider } from 'notistack';
import { store, persistor } from 'store';


const history = createBrowserHistory();
window.persistor = persistor;

const AppProvider = () => (
  <MuiThemeProvider theme={theme}>
    <Provider store={store}>
      <PersistGate loading={<LoadingScreen />} persistor={persistor}>
        <Router history={history}>
          <LastLocationProvider>
            <SnackbarProvider
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}>
              <App />
            </SnackbarProvider>
          </LastLocationProvider>
        </Router>
        <Notifications />
      </PersistGate>
    </Provider>
  </MuiThemeProvider>
);

ReactDOM.render(<AppProvider />, document.getElementById('root'));
